"use strict";
/**
 * A set of standard helpers for working with iterators.
 *
 * The majority of the utils included here can be removed if and when the tc39 iterator-helpers proposal lands:
 * https://github.com/tc39/proposal-iterator-helpers
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.drain = exports.reduce = exports.reduced = exports.filter = exports.map = exports.concat = void 0;
/**
 * Takes n number of streams (or any AsyncIterators) and returns an AsyncGenerator that
 * yields the concatenated output of all input streams
 */
async function* concat(...sources) {
    for (const source of sources) {
        yield* source;
    }
}
exports.concat = concat;
/**
 * Implements `Array.prototype.map` for iterables
 */
async function* map(iterable, transform) {
    for await (const element of iterable) {
        yield await transform(element);
    }
}
exports.map = map;
/**
 * Implements `Array.prototype.filter` for iterables
 */
async function* filter(iterable, comparator) {
    for await (const element of iterable) {
        if (await comparator(element)) {
            yield element;
        }
    }
}
exports.filter = filter;
const reduced = (value) => {
    return {
        __reduced: true,
        value
    };
};
exports.reduced = reduced;
const isReducedValue = (value) => {
    return '__reduced' in value && value.__reduced;
};
/**
 * Implements `Array.prototype.reduce` for iterables.
 *
 * The reducer can return `reduced(accumulator)` to end execution early
 */
const reduce = async (iterable, reducer, init) => {
    let accumulator = init;
    for await (const element of iterable) {
        const result = await reducer(accumulator, element);
        if (isReducedValue(result)) {
            return result.value;
        }
        accumulator = result;
    }
    return accumulator;
};
exports.reduce = reduce;
/**
 * Drain a given iterables contents into an array. This is kind of like `Array.from` except it works
 * with AsyncIterables
 */
const drain = async (iterator) => {
    const data = [];
    for await (const chunk of iterator) {
        data.push(chunk);
    }
    return data;
};
exports.drain = drain;
